import {Action, getModule, Module, Mutation} from 'vuex-module-decorators';
import store from '@/store';
import {PModule} from '@/views/system/modules/interfaces';
import {convertProcessStatus} from '@/views/system/modules/enums';
import authModule from '../../authModule';
import {openWebSocket} from '@/api/baseApi';
import {EntityModule} from '../entityModule';
import enumsModule, {transformFromModuleTypeStr} from '../../enumsModule';
import {httpClient} from '@/api/baseApi';
import {EntityData} from '@/interfaces/config';

/*
    Динамический модуль хранилища vuex для работы с программными модулями
*/

const moduleName = 'pmodulesModule';

export function transformGet(elem: any): PModule {
  const type = transformFromModuleTypeStr(elem.type);
  return {
    id: elem.id,
    guid: elem.guid,
    name: elem.name,
    description: elem.description,
    //TODO: пока не приходят с сервера
    processStatus: elem.process_status,
    processStatusDescription: elem.process_status_description,
    status: elem.status,
    type,
    //TODO: временное решение, пока с сервера не передается description
    typeDescription: enumsModule.moduleTypes.filter(x => x.value == type)[0].description,
    nodes: elem.nodes,
    nodeDescription: elem.node_description || '',
    span_nodes: elem.span_nodes,
  };
}

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
export class PModulesModule extends EntityModule {
  protected routeName = 'modules';

  get all(): PModule[] {
    return super.all as PModule[];
  }

  @Mutation
  patch(entities: PModule[]) {
    const copy = [...this.entities];
    entities.forEach(e => {
      for (let i = 0; i < copy.length; ++i) {
        const pm = copy[i] as PModule;
        if (pm.guid == e.guid) copy[i] = e;
      }
    });
    this.entities = copy;
  }

  @Mutation
  filterList(list: PModule[]) {
    this.entities = list;
  }

  @Action
  filterListAction(list: PModule[]) {
    this.context.commit('filterList', list);
  }

  //Получение списка объектов с сервера
  @Action
  public async fetchAll() {
    return super.fetchAll(transformGet);
  }

  // Получить модуль по guid
  @Action
  public async getPmodules(guids: any[]) {
    try {
      const {data} = await httpClient.get(`${this.routeName}/?guids=[${guids}]`);
      const transformData: EntityData[] = data.map((elem: any) => transformGet(elem));
      return {data: transformData};
    } catch (e) {
      return Promise.reject(e);
    }
  }

  /*
    Получить изменения статусов всех ПМ
  */
  @Action
  async statusesChangesWSConnection() {
    const accessToken = authModule.getAccessToken || '';
    return openWebSocket(`or_pm_manager/statuses/changes/?access_token=${accessToken}`);
  }

  /*
    Получить изменения всех ПМ
  */
  @Action
  async modulesChangesWSConnection() {
    const accessToken = authModule.getAccessToken || '';
    return openWebSocket(`modules_changes/?access_token=${accessToken}`);
  }

  /*
    Обновить статусы
  */
  @Action
  async updateStatuses(params: {statusMap: Record<string, string>}) {
    const entities = (this.entities as PModule[])
      .filter(x => x.guid && x.guid in params.statusMap)
      .map(x => ({...x}));
    entities.forEach(
      x => (x.processStatus = convertProcessStatus(params.statusMap[x.guid as string])),
    );
    this.patch(entities);
  }

  /*
    Обновить данные модуля
  */
  @Action
  async updateModules(params: {_id: string; data: {status: string}}) {
    const entities = (this.entities as PModule[])
      .filter(x => x.guid && x.guid == params._id)
      .map(x => ({...x}));
    entities.forEach(x => (x.status = params.data.status));
    this.patch(entities);
  }
}

export default getModule(PModulesModule);
